// Données et helpers partagés par les onglets de l'AvocatSheet
import { Label } from "@/components/ui/label";

export const QC_DISTRICTS = [
    { id: 1,  nom: "Abitibi" },        { id: 2,  nom: "Alma" },
    { id: 3,  nom: "Arthabaska" },     { id: 4,  nom: "Baie-Comeau" },
    { id: 5,  nom: "Beauce" },         { id: 6,  nom: "Beauharnois" },
    { id: 7,  nom: "Bedford" },        { id: 8,  nom: "Bonaventure" },
    { id: 9,  nom: "Charlevoix" },     { id: 10, nom: "Chicoutimi" },
    { id: 11, nom: "Drummond" },       { id: 12, nom: "Frontenac" },
    { id: 13, nom: "Gaspé" },          { id: 14, nom: "Hull" },
    { id: 15, nom: "Iberville" },      { id: 16, nom: "Joliette" },
    { id: 17, nom: "Kamouraska" },     { id: 18, nom: "Labelle" },
    { id: 19, nom: "Laval" },          { id: 20, nom: "Longueuil" },
    { id: 21, nom: "Mégantic" },       { id: 22, nom: "Mingan" },
    { id: 23, nom: "Montmagny" },      { id: 24, nom: "Montréal" },
    { id: 25, nom: "Pontiac" },        { id: 26, nom: "Québec" },
    { id: 27, nom: "Richelieu" },      { id: 28, nom: "Rimouski" },
    { id: 29, nom: "Roberval" },       { id: 30, nom: "Royun-Noranda" },
    { id: 31, nom: "Saint-François" }, { id: 32, nom: "Saint-Hyacinthe" },
    { id: 33, nom: "Saint-Maurice" },  { id: 34, nom: "Témiscamingue" },
    { id: 35, nom: "Terrebonne" },     { id: 36, nom: "Trois-Rivières" },
];

export const EMPTY_AVOCAT = {
    code: "", type_code: "A", nom: "", prenom: "",
    sectbar: "", annee_barreau: "", codebar: "", nas: "", neq: "", taxes: "",
    villerref: "", comm: "",
    // Tous les toggles à false par défaut lors de la création — l'utilisateur
    // peut ensuite les activer explicitement (cohérent avec l'attente UX :
    // « un nouveau dossier vierge »).
    actif: false, payable: false, mega: false,
    depodirect: false, factweb: false, confweb: false, surveil: false,
    adresse: { address: "", ville: "", province: "QC", codepostal: "", telephone: "", email: "" },
};

export const EMPTY_ADRESSE = {
    address: "", adresse2: "", adresse3: "", ville: "", province: "QC",
    codepostal: "", telephone: "", telephone2: "", poste1: "", poste2: "",
    fax: "", email: "",
};

export const EMPTY_MEGA = {
    sectbar: "", francais: true, anglais: false, autres: "", experience: 0,
    details: "", art486: false, art672: false, art684: false, LPJ85: false, CPC278: false,
    commentaire: "", dateinsc: "", districthab: "", districts: [], tous_districts: false,
};

// Petit composant Field — label + enfant (input/select/etc.)
// `required` ajoute un astérisque rouge à droite du label.
export const Field = ({ label, children, required = false }) => (
    <div className="space-y-1.5">
        <Label className="text-[11px] font-semibold uppercase tracking-wider text-slate-600">
            {label}
            {required && (
                <span className="text-red-600 ml-0.5" aria-label="champ obligatoire">*</span>
            )}
        </Label>
        {children}
    </div>
);
